import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import AreaChart from "../../../Components/Charts/AreaChart";
import { axInst } from "../../../Components/Login/Service";

const fetchDealerProfitibility = async (body) => {
  try {
    const res = await axInst.post(
      "collbax-service/collbax_zone_job_card",
      body,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export default function DealerProfitibility() {
  const { data, submitted } = useSelector((e) => e.filtersServiceCollabax);

  const {
    data: apiData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["dealerProfitibility", submitted],
    queryFn: () => fetchDealerProfitibility(data),
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (isError) return <div>Error loading data</div>;

  // 🔥 Transform API response correctly
  const chartsData = apiData
    ? Object.entries(apiData).map(([title, value]) => {
        const keys = Object.keys(value);
        const prevFY = keys.find((key) => key.startsWith("FY"));
        const currFY = keys.find((key) => key.startsWith("YTD_FY"));

        return {
          title,
          monthlyData: value.Month_wise_revenue || {},
          target: value.Target,
          previousYear: {
            label: prevFY,
            value: prevFY ? value[prevFY] : null,
          },
          ytdActual: currFY
            ? { label: currFY, value: value[currFY] }
            : value.YTD_Actual,
        };
      })
    : [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      {chartsData.map((chart, index) => {
        let endpoint = "collbax-service/collbax_sso_job_card";
        let modalPayload = {};

        const titleLower = chart?.title?.toLowerCase() || "";

        if (titleLower.includes("veh") && titleLower.includes("bay")) {
          endpoint = "collbax-service/collbax_service_sso_operational_efficiency";
          if (titleLower.includes("dealer") || titleLower.includes("dlr")) {
            modalPayload = { Partner_Type: ["Dealer"], sso_status: "VEH_BAY" };
          } else if (titleLower.includes("tass") || titleLower.includes("taas")) {
            modalPayload = { Partner_Type: ["TASS"], sso_status: "VEH_BAY" };
          } else {
            modalPayload = { Partner_Type: [], sso_status: "VEH_BAY" };
          }
        } else if (titleLower.includes("open") && titleLower.includes("job") && titleLower.includes("card")) {
          endpoint = "collbax-service/collbax_service_sso_operational_efficiency";
          if (titleLower.includes("dealer") || titleLower.includes("dlr")) {
            modalPayload = { Partner_Type: ["Dealer"], sso_status: "OPEN_JOB_CARD" };
          } else if (titleLower.includes("tass") || titleLower.includes("taas")) {
            modalPayload = { Partner_Type: ["TASS"], sso_status: "OPEN_JOB_CARD" };
          } else {
            modalPayload = { Partner_Type: [], sso_status: "OPEN_JOB_CARD" };
          }
        } else if (titleLower.includes("cpsc")) {
          endpoint = "collbax-service/collbax_service_sso_operational_efficiency";
          modalPayload = { sso_status: "CPSC_PERCENT" };
        }

        return (
          <AreaChart
            key={index}
            title={chart.title}
            data={chart.monthlyData}
            target={chart.target}
            previousYear={chart.previousYear}
            ytdActual={chart.ytdActual}
            modalEndpoint={endpoint}
            modalPayload={modalPayload}
          />
        );
      })}
    </div>
  );
}
